import { FC } from 'react';
import { Link } from 'react-router-dom';

import { useTranslate } from 'hooks/useTranslate';

type EquityMarketAdminPanelConfigurationOfferConditionsProps = {
  societyId: string;
};

const EquityMarketAdminPanelConfigurationOfferConditions: FC<
  EquityMarketAdminPanelConfigurationOfferConditionsProps
> = ({ societyId }) => {
  const { t } = useTranslate();

  return (
    <div className="card card-bordered mb-4">
      <div className="card-inner">
        <h6 className="card-title mb-1">
          <em className="icon ni ni-file-docs mr-2 text-primary" />
          {t('EquityMarketAdminConfigSection1Title')}
        </h6>
        <p className="text-soft fs-13px mb-4">
          {t('EquityMarketAdminConfigSection1Description')}
        </p>

        <div className="doc-item align-items-start align-items-md-center">
          <div className="doc-icon bg-primary-dim text-primary">
            <em className="icon ni ni-file-docs" />
          </div>

          <div className="flex-grow-1">
            <strong className="fs-13px d-block">
              {t('EquityMarketAdminConfigOfferConditionsTitle')}
            </strong>
            <div className="text-soft fs-12px">
              {t('EquityMarketAdminConfigOfferConditionsSubtitle')}
            </div>
          </div>

          <div className="d-flex align-items-center flex-wrap flex-shrink-0 mt-3 mt-md-0 ml-md-3">
            <Link
              to={`/condiciones-ofertas/${societyId}`}
              className="btn btn-outline-secondary btn-sm mr-2 mb-2 mb-md-0"
            >
              {t('EquityMarketConditionsViewPage')}
            </Link>
            <Link
              to={`/condiciones-ofertas/${societyId}`}
              className="btn btn-primary btn-sm mb-2 mb-md-0 is-disable"
            >
              {t('Edit')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquityMarketAdminPanelConfigurationOfferConditions;
